export default ($axios, cookieService, baseUrl) => ({
  cultureDefault(prevCurrency) {
    return $axios.get(`${baseUrl}culture/defaults?prevCurrency=` + prevCurrency).then(
      () => {},
      () => {
        cookieService.set('culture', 'lang=en&currency=USD&country=US')
      }
    )
  },
  isSet() {
    const cookie = cookieService.get('culture')
    return cookie !== undefined && cookie !== null && cookie.length > 0
  },
  getLanguage() {
    return cookieService.get('culture', 'lang') ?? 'en'
  },
  getCurrency() {
    return cookieService.get('culture', 'currency') ?? 'USD'
  },
  getCountry() {
    return cookieService.get('culture', 'country') ?? 'US'
  },
  setLanguage(lang) {
    cookieService.update('culture', 'lang', lang)
  },
  setCurrency(currency) {
    cookieService.update('culture', 'currency', currency)
  },
  setCountry(country) {
    cookieService.update('culture', 'country', country)
  },
})
